
import { Component, Vue } from "vue-property-decorator";
import { GaodeService, OrganizationService, PackageService, OrderService, FamilyService } from "src/services";
import { Toast, Dialog } from "vant";
import dayjs from "dayjs";
import { CHECK_STATUS, ORDER_STATUS } from "src/enums";
import { EnumUtils, tools } from "src/utils";



@Component
export default class OfteUser extends Vue
{

    /**
     * 订单状态
     * @private
     * @returns number
     */
    private get orderStatus(): number
    {
        if(this.$route.query && this.$route.query.orderStatus)
        {
            if (+this.$route.query.orderStatus == 77)
            {
                document.title = "提交成功";
            }
            return +this.$route.query.orderStatus;
        }
        return null;
    }

    /**
     * 订单id
     * @private
     * @returns number
     */
    private get orderId(): string
    {
        if(this.$route.query && this.$route.query.id)
        {
           return this.$route.query.id +"";
        }

        return null;
    }

    /**
     * 是否包含非体检
     * @private
     * @returns number
     */
    private get hasHealthProduct(): boolean
    {
        if(this.$route.query && this.$route.query.hasHealthProduct)
        {
           return !!this.$route.query.hasHealthProduct;
        }

        return null;
    }

    /**
     * 跳转订单详情
     * @private
     * @returns number
     */
    private onOrderDetail(): void
    {
        // this.$router.push({name: "order-list"});
        this.$router.push({name: "orderDetail", params:{id: this.orderId},query:{reportId:this.orderId}});
    }

    /**
     * 跳转订单详情
     * @private
     * @returns number
     */
    private onPersonalCenter(): void
    {
        this.$router.push({name: "personal-center"});
    }

    /**
     * 跳转套餐列表
     * @private
     * @returns number
     */
    private onPackageList(): void
    {
        this.$router.push({name: "physical-package", query:{type: "2"}})
    }


}
